import React, { useEffect, useState } from "react";
import { FiPlus } from "react-icons/fi";
import { GoEye } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../../layout/AdminLayout";
import AddOwner from "./AddOwner";
import { getAllOwners } from "../../../api/owners.api";
import { MoonLoader } from "react-spinners"; // Import the loader

function Owners() {
  const navigate = useNavigate();
  const [addOwnerOpen, setAddOwnerOpen] = useState(false);
  const [ownersData, setOwnersData] = useState([]);
  const [editOwnerId, setEditOwnerId] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchAllOwners = () => {
    setLoading(true); // Start loading before fetch
    getAllOwners()
      .then((res) => {
        setOwnersData(res?.data?.owners || []);
        console.log("owner data", res?.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setLoading(false); // Stop loading after fetch completes
      });
  };

  useEffect(() => {
    fetchAllOwners();
  }, []);

  return (
    <>
      <AddOwner
        open={addOwnerOpen}
        setOpen={setAddOwnerOpen}
        fetchAllOwners={fetchAllOwners}
        editOwnerId={editOwnerId}
      />
      <AdminLayout title="Owners">
        <div className="px-1 sm:px-3 lg:px-8">
          <div className="mb-5 flex items-center justify-end sticky top-16 bg-slate-50 py-3 z-10 px-2">
            <button
              onClick={() => {
                setAddOwnerOpen(true);
                setEditOwnerId(null);
              }}
              className="flex items-center justify-center rounded-md bg-yellowColor px-3 py-2.5 text-base font-semibold text-gray-700 shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellowColor"
            >
              {" "}
              <FiPlus className="text-lg text-gray-700" />
              Add Owner
            </button>
          </div>
          {loading ? (
            <div className="flex justify-center items-center h-96">
              <MoonLoader color="black" size={50} />
            </div>
          ) : (
            <div className="mt-5 flow-root">
              {ownersData.length === 0 ? (
                <>
                  <div className="text-center font-bold text-gray-600 text-xl my-4">
                    No Owners added.
                  </div>
                </>
              ) : (
                <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <table className="bg-white rounded-lg min-w-full divide-y divide-gray-300">
                      <thead>
                        <tr>
                          <th className="px-6 py-3 bg-gray-50 text-left text-lg font-medium text-gray-500 uppercase">
                            Owner Information
                          </th>
                          <th className="px-6 py-3 bg-gray-50 text-left text-lg font-medium text-gray-500 uppercase">
                            Bank Information
                          </th>
                          <th className="px-6 py-3 bg-gray-50 text-left text-lg font-medium text-gray-500 uppercase">
                            User Information
                          </th>
                          <th className="px-6 py-3 bg-gray-50 text-left text-lg font-medium text-gray-500 uppercase">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 ">
                        {ownersData.map((owner, index) => (
                          <tr key={index}>
                            <td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0">
                              <div className=" bg-gray-50 rounded-md p-4 ml-4 flex flex-col items-start justify-center">
                                <div className="">
                                  <div>
                                    <h1 className="text-gray-600 font-semibold text-base">
                                      Name
                                    </h1>
                                    <span className="text-gray-400 font-semibold text-base">
                                      {owner?.name}
                                    </span>
                                  </div>
                                  <div className="mt-5 ">
                                    <h1 className="text-gray-600 font-semibold text-base">
                                      Email
                                    </h1>
                                    <span className="text-gray-400 font-semibold text-base">
                                      {owner?.email}
                                    </span>
                                  </div>
                                  <div className="mt-5 ">
                                    <h1 className="text-gray-600 font-semibold text-base">
                                      Phone
                                    </h1>
                                    <span className="text-gray-400 font-semibold text-base">
                                      {owner?.phone}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="pr-3 py-5 text-sm ">
                              <div className="bg-gray-50 rounded-md p-4">
                                <div>
                                  <h1 className="text-gray-600 font-semibold text-base">
                                    Account Holder
                                  </h1>
                                  <span className="text-gray-400 font-semibold text-base">
                                    {owner?.bankInfo?.accountHolder}
                                  </span>
                                </div>
                                <div className="mt-5 ">
                                  <h1 className="text-gray-600 font-semibold text-base">
                                    Account Number
                                  </h1>
                                  <span className="text-gray-400 font-semibold text-base">
                                    {owner?.bankInfo?.accountNumber}
                                  </span>
                                </div>
                                <div className="mt-5 ">
                                  <h1 className="text-gray-600 font-semibold text-base">
                                    Bank Name
                                  </h1>
                                  <span className="text-gray-400 font-semibold text-base">
                                    {owner?.bankInfo?.bankName}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td className="pr-3 py-5 text-sm ">
                              <div className="bg-gray-50 rounded-md p-4">
                                <div>
                                  <h1 className="text-gray-600 font-semibold text-base">
                                    User Name
                                  </h1>
                                  <span className="text-gray-400 font-semibold text-base">
                                    {owner?.user_info?.firstName}{" "}
                                    {owner?.user_info?.lastName}
                                  </span>
                                </div>
                                <div className="mt-5 ">
                                  <h1 className="text-gray-600 font-semibold text-base">
                                    User Email
                                  </h1>
                                  <span className="text-gray-400 font-semibold text-base">
                                    {owner?.user_info?.email}
                                  </span>
                                </div>
                                <div className="mt-5 ">
                                  <h1 className="text-gray-600 font-semibold text-base">
                                    User Role
                                  </h1>
                                  <span className="text-gray-400 font-semibold text-base">
                                    {owner?.user_info?.role}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td className="relative whitespace-nowrap py-5  text-right text-sm font-medium sm:pr-0">
                              <button
                                onClick={() => {
                                  navigate(`/owners/${owner._id}`);
                                }}
                                className="text-xl h-10 w-10 ms-3 bg-blue-300 flex items-center justify-center text-dark py-0.5 px-2 rounded-md"
                              >
                                <GoEye />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </AdminLayout>
    </>
  );
}

export default Owners;
